module.exports = __webpack_public_path__ + "img/upload.163ef20d.svg";